<maps-drawer label="Candidate experience" headerStyle="navy" (closed)="closed.emit()" #drawer>
    <div drawerTitle class="who" data-testid="experience-drawer-title">
        <h2>{{ displayName }}</h2>
        <p class="role" *ngIf="roleLine">{{ roleLine }}</p>
        <p class="loc" *ngIf="locationText">{{ locationText }}</p>
        <p
            class="contact-status"
            data-testid="drawer-contact-status"
            [class.failure]="contactStatusIsFailure"
            *ngIf="contactStatusText">
            {{ contactStatusText }}
        </p>
    </div>

    <div class="sections">
        <maps-why-suggested-box
            [text]="candidate.whySuggested ?? null"
            [failed]="summariesFailed"
            [full]="true"
            (retry)="summariesRetry.emit()"></maps-why-suggested-box>

        <maps-things-to-look-into-box
            [text]="candidate.thingsToLookInto ?? null"
            [flags]="candidate.fitFlags ?? null"
            [failed]="summariesFailed"
            [full]="true"
            (retry)="summariesRetry.emit()"></maps-things-to-look-into-box>

        <section class="experience" aria-label="Work experience">
            <header>{{ experienceHeading }}</header>
            <ol *ngIf="timeline.length > 0; else noHistory">
                <li *ngFor="let row of timeline" [class.is-last]="row.last">
                    <span class="marker" aria-hidden="true">
                        <span class="dot"></span>
                        <span class="line" *ngIf="!row.last"></span>
                    </span>
                    <span class="detail">
                        <span class="title" *ngIf="row.title">{{ row.title }}</span>
                        <span class="meta" *ngIf="row.meta">{{ row.meta }}</span>
                    </span>
                </li>
            </ol>
            <ng-template #noHistory>
                <p class="none" role="status">No verified work history on file — contact them directly for details.</p>
            </ng-template>
        </section>

        <section class="profiles" aria-label="External profiles" *ngIf="hasProfileLinks">
            <header>Profiles</header>
            <maps-profile-links [candidate]="candidate"></maps-profile-links>
        </section>
    </div>

    <div drawerFooter class="footer-actions">
        <!-- Opens the contact modal ABOVE this drawer — native top-layer
             dialogs stack, so Escape peels the modal first. -->
        <button type="button" class="btn primary" data-testid="drawer-contact" (click)="contact.emit()">
            Contact
        </button>
        <button type="button" class="btn secondary" (click)="drawer.Close()">Close</button>
    </div>
</maps-drawer>
